import { render } from "./MigracionGarantias.vue?vue&type=template&id=4d5ba89a"
import script from "./MigracionGarantias.vue?vue&type=script&lang=js"
export * from "./MigracionGarantias.vue?vue&type=script&lang=js"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__